import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f2e7336"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Tasks" }
const _hoisted_2 = { class: "mt-4 bg-white rounded" }
const _hoisted_3 = { class: "flex items-center justify-end py-3" }
const _hoisted_4 = { class: "TasksTable" }
const _hoisted_5 = {
  key: 0,
  class: "flex flex-col items-center justify-center text-sm text-gray-400 select-none"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-1" }, "Загрузка списка...", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-red-500" }, "При получении списка произошла ошибка", -1))
const _hoisted_8 = { key: 2 }
const _hoisted_9 = {
  key: 1,
  class: "TasksTable"
}
const _hoisted_10 = { class: "flex items-center justify-end pb-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CrmUpdateTaskOnCall = _resolveComponent("CrmUpdateTaskOnCall")!
  const _component_CrmTasksFilters = _resolveComponent("CrmTasksFilters")!
  const _component_new_limit = _resolveComponent("new-limit")!
  const _component_new_pagination = _resolveComponent("new-pagination")!
  const _component_loader = _resolveComponent("loader")!
  const _component_new_button = _resolveComponent("new-button")!
  const _component_tasks_row = _resolveComponent("tasks-row")!
  const _component_new_table = _resolveComponent("new-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.update_task_on_call_state.is_opened)
      ? (_openBlock(), _createBlock(_component_CrmUpdateTaskOnCall, {
          key: 0,
          task: _ctx.update_task_on_call_state.task,
          onCancel: _ctx.onUpdateTaskOnCallCancel,
          onSubmit: _ctx.onUpdateTaskOnCallSubmit
        }, null, 8, ["task", "onCancel", "onSubmit"]))
      : _createCommentVNode("", true),
    _createVNode(_component_CrmTasksFilters, {
      class: "mt-3",
      loading: _ctx.state.is_loading,
      disabled: _ctx.state.is_loading,
      onSubmit: _ctx.onFiltersChanged,
      onReset: _ctx.onFiltersReset
    }, null, 8, ["loading", "disabled", "onSubmit", "onReset"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_new_limit, {
          disabled: _ctx.state.is_loading,
          value: _ctx.state.pagination.limit,
          "total-items": _ctx.state.pagination.total_items,
          onChange: _ctx.onLimitChange
        }, null, 8, ["disabled", "value", "total-items", "onChange"]),
        _createVNode(_component_new_pagination, {
          class: "ml-6",
          disabled: _ctx.state.is_loading,
          "current-page": _ctx.state.pagination.page,
          "total-pages": _ctx.state.pagination.total_pages,
          onChangePage: _ctx.onChangePage
        }, null, 8, ["disabled", "current-page", "total-pages", "onChangePage"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.state.is_loading || _ctx.state.is_failed || _ctx.state.list.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_ctx.state.is_loading)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_loader, { class: "primary" }),
                    _hoisted_6
                  ], 64))
                : (_ctx.state.is_failed)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _hoisted_7,
                      _createVNode(_component_new_button, {
                        class: "mt-1",
                        onClick: _ctx.loadTasks
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Перезагрузить ")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ], 64))
                  : (_ctx.state.list.length === 0)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_8, "Список пуст"))
                    : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(_component_new_table, {
                columns: _ctx.TABLE_COLUMNS,
                rows: _ctx.state.list
              }, {
                td: _withCtx(({ column, row }) => [
                  _createVNode(_component_tasks_row, {
                    column: column,
                    row: row,
                    onUpdateTask: _ctx.onUpdateTaskOnCall
                  }, null, 8, ["column", "row", "onUpdateTask"])
                ]),
                _: 1
              }, 8, ["columns", "rows"])
            ]))
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_new_limit, {
          disabled: _ctx.state.is_loading,
          value: _ctx.state.pagination.limit,
          "total-items": _ctx.state.pagination.total_items,
          onChange: _ctx.onLimitChange
        }, null, 8, ["disabled", "value", "total-items", "onChange"]),
        _createVNode(_component_new_pagination, {
          class: "ml-6",
          disabled: _ctx.state.is_loading,
          "current-page": _ctx.state.pagination.page,
          "total-pages": _ctx.state.pagination.total_pages,
          onChangePage: _ctx.onChangePage
        }, null, 8, ["disabled", "current-page", "total-pages", "onChangePage"])
      ])
    ])
  ]))
}